import React from "react";
import {
  HelpDeskTicket,
  HelpDeskTicketStatus,
  HelpDeskTicketStatusTranslation,
} from "../../types/help_desk_tickets.types";
import { DATE_TIME_WEEKDAY_LONG_24H } from "../../utils/date-formats";
import Label from "../../components/label";

interface HDTListProps {
  hdTickets: HelpDeskTicket[];
  onSelectRequest: (request: HelpDeskTicket) => void;
}

export const HDTList: React.FC<HDTListProps> = ({
  hdTickets,
  onSelectRequest,
}) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Tus Solicitudes de Ayuda
      </h2>

      {hdTickets.length === 0 ? (
        <div className="text-center text-gray-500 py-8">
          <p>Todavía no tenes ninguna solicitud de ayuda.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {hdTickets.map((request) => (
            <div
              key={request.id}
              className={`border-l-4 ${
                request.status === HelpDeskTicketStatus.Resolved
                  ? "border-green-500"
                  : "border-yellow-500"
              } bg-white p-4 rounded shadow-sm`}
            >
              <div className="flex justify-between items-start mb-1">
                <h3 className="font-semibold text-gray-800">{request.title}</h3>

                <Label
                  color={
                    request.status === HelpDeskTicketStatus.Pending
                      ? "yellow"
                      : "green"
                  }
                >
                  {HelpDeskTicketStatusTranslation[request.status]}
                </Label>
              </div>

              <div className="text-xs text-gray-500 mb-2">
                Enviado el{" "}
                {new Date(request.created_at).toLocaleDateString(
                  "es-AR",
                  DATE_TIME_WEEKDAY_LONG_24H
                )}
              </div>

              <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                {request.description}
              </p>

              <div className="flex justify-end">
                <button
                  onClick={() => onSelectRequest(request)}
                  className="text-sm text-blue-500 hover:text-blue-700 hover:underline"
                >
                  Ver detalles →
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
